/**
 * Shared constants for benefits page PDF generation.
 * Used by benefitsPdfGenerator for capture dimensions and page-break logic.
 */

// -----------------------------------------------------------------------------
// PDF generation (benefitsPdfGenerator)
// -----------------------------------------------------------------------------

export const PDF_PAGE_WIDTH_PT = 595;
export const PDF_PAGE_HEIGHT_PT = 842;
export const PDF_SCALE = 2.5;
export const CAPTURE_WIDTH_PX = 1080;
export const CAPTURE_SCALE = 2.5;
export const CAPTURE_PADDING_PX = 8;
/** Ms to wait after clone is in DOM before html2canvas (layout/paint). */
export const CAPTURE_STABILIZE_MS = 300;
export const PAGE_BREAK_SEARCH_RADIUS_PX = 80;
export const PAGE_BREAK_STRIP_HEIGHT_PX = 6;
export const PAGE_BREAK_WHITE_THRESHOLD = 248;
export const PAGE_TOP_BUFFER_PX = 24;
/** Margin (in pt) added to all four sides of each PDF page so content isn't flush to the edge. */
export const PDF_PAGE_MARGIN_PT = 24;

/** DOM ids of section wrappers (match PatientBenefitsCombinedPage). Used for page-break boundaries. */
export const SECTION_IDS = [
  'patient-information-section',
  'coverage-summary-section',
  'coverage-details',
  'maximums-deductibles-section',
  'limitations-and-disclaimers-section',
  'waiting-periods-section',
  'treatment-history-section',
] as const;
